import { createContext } from 'react';

import shinkansen, { Shinkansen } from './shinkansen';

export interface StoreContextValue {
  shinkansen: Shinkansen;
}

const storeContext = createContext<StoreContextValue>({
  shinkansen
});

export default storeContext;
